import { useQuery } from '@tanstack/react-query';
import { loadSessions } from '../content/sessions';
import { queryKeys } from '../query/keys';
import { useConfig, useSession } from './provider';

/** The participant's sessions (newest first) — everything Home and Progress derive from. */
export function useSessions() {
  const session = useSession();
  const { strongerMemoryTypes: types } = useConfig();
  return useQuery({
    queryKey: queryKeys.sessions(),
    enabled: session.status === 'authenticated' && types !== undefined,
    staleTime: 60_000,
    queryFn: () => loadSessions(types as NonNullable<typeof types>),
  });
}
